// Revival: when Rebuy Smart Cart is active (body.smart-cart--enabled), the header cart button
// opens the Smart Cart instead of Horizon's cart drawer. With Smart Cart off, Horizon behaves normally.
(function () {
  function smartCart() {
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    return document.body.classList.contains('smart-cart--enabled') && sc && typeof sc.show === 'function' ? sc : null;
  }
  window.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var trigger = target.closest('[on\\:click="#cart-drawer/toggle"], [on\\:click="#cart-drawer/open"], cart-icon');
    if (!trigger) return;
    var sc = smartCart();
    if (!sc) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sc.show();
  }, true);
})();
